export default function SearchQuery({ text = '', type = 'header' }) {
  const variants = {
    header: 'truncate max-w-xs',
    page: 'py-2',
  };

  return (
    <div className="px-2 flex items-center min-w-0">
      <div className="text-gray text-2xl pr-1">
        <i className="bx bx-search"></i>
      </div>
      <span className={`${variants[type]} text-sm sm:max-w-sm `}>{text}</span>
    </div>
  );
}
